const PlayIcon = () => {

    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.90625 17.4375V5.4375L16.0938 11.4375L7.90625 17.4375Z" stroke="currentColor" shapeRendering="crispEdges"/>
    </svg>
}

export default PlayIcon;